import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLock = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 15,
	fill: "none",
	viewBox: "0 0 14 15",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M7 1.76831C5.76953 1.76831 4.8125 2.75269 4.8125 3.95581V5.26831L9.1875 5.26831L9.1875 3.95581C9.1875 2.75269 8.20312 1.76831 7 1.76831ZM3.0625 3.95581C3.0625 1.79565 4.8125 0.0183105 7 0.0183105C9.16016 0.0183105 10.9375 1.79565 10.9375 3.95581L10.9375 5.26831H11.375C12.332 5.26831 13.125 6.06128 13.125 7.01831V12.2683C13.125 13.2527 12.332 14.0183 11.375 14.0183L2.625 14.0183C1.64063 14.0183 0.875 13.2527 0.875 12.2683L0.875 7.01831C0.875 6.06128 1.64063 5.26831 2.625 5.26831H3.0625V3.95581ZM7.875 8.76831C7.875 8.30347 7.46484 7.89331 7 7.89331C6.50781 7.89331 6.125 8.30347 6.125 8.76831V10.5183C6.125 11.0105 6.50781 11.3933 7 11.3933C7.46484 11.3933 7.875 11.0105 7.875 10.5183V8.76831Z"
	})
});
const ForwardRef = forwardRef(SvgLock);
export default ForwardRef;
